var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topicListBg"},[_c('div',{staticClass:"topicListContent"},[_c('banner',{staticStyle:{"padding-top":"61px"}}),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('examRehearsal')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }